import { RuleTypes } from '@src/api/selection';

export const ruleItems = [
  { name: "Patient's age in years", value: RuleTypes.PatientAgeRule },
  { name: "Patient's birth sex", value: RuleTypes.PatientBirthSexRule },
  { name: 'Result ref. values', value: RuleTypes.ResultRefValueRule },
  { name: 'Result', value: RuleTypes.ResultRule },
  { name: 'Missing result', value: RuleTypes.MissingResultRule },
  { name: 'Conditions and Diagnoses', value: RuleTypes.ConditionAndDiagnosisRule },
];
